<template>
  <footer :class="[modifyFooter]">
    <emd-terms-of-use-modal v-if="canShowTermsOfUseModal" :open="showTermsOfUseModal" @close="toggleTermsOfUseModal" />

    <emd-footer-secure-env
      v-if="secureEnv.show"
      :isLink="secureEnv.isLink"
      :urlSite="secureEnv.url"
      :iconClass="secureEnv.iconClass"
      :icon="secureEnv.icon" />

    <ul :class="['emd-list emd-text _inline', modifyUl]">

        <li class="emd-item_divider" id="documentation" v-if="documentation.show">
          <a
            class="emd-link _color_subtle"
            rel="noopener noreferrer"
            target="_blank"
            :href="documentation.url">{{$t("documentation") }}</a>
          <span class="emd-text _color_nonessential eu-ml_2 "></span>
        </li>

        <li class="emd-item_divider" id="privacy-security" v-if="privacySecurity.show">
          <a
            class="emd-link _color_subtle"
            :href="privacySecurity.url"
            target="_blank"
            tabindex="-2">{{ $t('privacy') }}</a>
          <span class="emd-text _color_nonessential eu-ml_2 "></span>
        </li>

        <li class="emd-item_divider" id="help" v-if="help.show">
          <a
            class="emd-link _color_subtle"
            :href="help.url"
            target="_blank"
            tabindex="-2">{{ $t('help') }}</a>
          <span class="emd-text _color_nonessential eu-ml_2"></span>
        </li>

        <li class="emd-item_divider eu-display_inline-flex" v-if="status.show">
          <emd-status-tag :status="currentStatus" :url="status.url" :label="$t('status')" />
          <span class="emd-text _color_nonessential eu-ml_2"></span>
        </li>

        <li class="emd-item_divider" v-if="switchLanguage.show">
          <emd-language-select
            v-model="switchLanguage.value"
            color="subtle"
            style="vertical-align: 4px"
            @input="changeLanguage" />
          <span class="emd-text _color_nonessential eu-ml_2"></span>
        </li>
      </ul>

      <ul :class="['emd-list emd-text _inline', modifyUl]">
        <li class="emd-item_divider" id="terms-of-use" v-if="termsOfUse.show">
          <component
            :is="termsOfUse.component"
            class="emd-link _color_subtle"
            rel="noopener noreferrer"
            target="_blank"
            :href="termsOfUse.url"
            @click="toggleTermsOfUseModal">{{$t("terms-of-use") }}</component>
          <span class="emd-text _color_nonessential eu-ml_2"></span>
        </li>

        <li id="privacy-policy" v-if="privacyPolicy.show">
          <a
            class="emd-link _color_subtle"
            rel="noopener noreferrer"
            target="_blank"
            :href="privacyPolicy.url">{{$t("privacy-policy") }}</a>
        </li>
      </ul>

    <emd-switch-theme-mode
      v-if="switchThemeMode.show"
      :align="switchThemeMode.align"
      :position="switchThemeMode.position"
      :isDark="switchThemeMode.isDark"
      :value="switchThemeMode.mode"
      @input="changeThemeMode" />

  </footer>
</template>

<script>
import axios from 'axios'
import EmdStatusTag from '../../../emerald/atoms/emdStatusTag/EmdStatusTag.vue'
import EmdLanguageSelect from '../../../emerald/atoms/emdLanguageSelect/EmdLanguageSelect.vue'
import EmdSwitchThemeMode from '../../../emerald/atoms/emdSwitchThemeMode/EmdSwitchThemeMode.vue'
import EmdFooterSecureEnv from './childrenComponents/EmdFooterSecureEnv.vue'
import EmdTermsOfUseModal from './childrenComponents/EmdTermsOfUseModal.vue'

export default {
  name: 'EmdFooterInternal',
  components: {
    EmdStatusTag,
    EmdLanguageSelect,
    EmdSwitchThemeMode,
    EmdFooterSecureEnv,
    EmdTermsOfUseModal
  },
  props: {
    secureEnv: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    documentation: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    privacySecurity: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    help: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    status: {
      type: Object,
      default: () => {
        return {
          show: false,
          current: ''
        }
      }
    },
    termsOfUse: {
      type: Object,
      default: () => {
        return {
          show: false,
          component: 'span'
        }
      }
    },
    privacyPolicy: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    switchLanguage: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    switchThemeMode: {
      type: Object,
      default: () => {
        return { show: false }
      }
    },
    listStyle: {
      type: Object,
      default: () => {
        return {
          space: 'small',
          align: 'center',
          footerClassList: []
        }
      }
    }
  },
  data () {
    return {
      termsOfUseModalLocal: false,
      currentStatus: ''
    }
  },
  computed: {
    modifyUl () {
      const classes = []
      if (this.listStyle.space) {
        classes.push(`_space_${this.listStyle.space}`)
      }
      if (this.listStyle.align) {
        classes.push(`_align_${this.listStyle.align}`)
      }
      return classes
    },
    modifyFooter () {
      const classes = []
      if (this.listStyle.footerClassList) {
        classes.push(this.listStyle.footerClassList)
      }
      return classes
    },
    canShowTermsOfUseModal () {
      return (this.termsOfUse.modalExternal || this.termsOfUse.show) && this.showTermsOfUseModal
    },
    showTermsOfUseModal () {
      return this.termsOfUse.modalExternal ? this.termsOfUse.showModal : this.termsOfUseModalLocal
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$emit('changeLanguage', lang)
    },
    changeThemeMode (isDark, mode) {
      this.$emit('changeThemeMode', mode)
    },
    getStatus () {
      const api = axios.create()
      api
        .get(`${this.status.url}api/v2/status.json`)
        .then(response => (this.currentStatus = response.data.status.indicator))
    },
    toggleTermsOfUseModal () {
      if (this.termsOfUse.modalExternal) this.$emit('closeTermsOfUseModal')
      else if (this.termsOfUse.component === 'span') this.termsOfUseModalLocal = !this.termsOfUseModalLocal
    }
  },
  beforeMount () {
    if (this.status.show) this.getStatus()
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "documentation": "Documentação",
    "help": "Ajuda",
    "status": "Status",
    "privacy": "Privacidade e Segurança",
    "terms-of-use": "Termos de Uso",
    "privacy-policy": "Aviso de Privacidade"
  },
  "en-US": {
    "documentation": "Documentation",
    "help": "Help",
    "status": "Status",
    "privacy": "Privacy and Security",
    "terms-of-use": "Terms of Use",
    "privacy-policy": "Privacy Policy"
  }
}
</i18n>

<style scoped>
.emd-item_divider:not(:last-child):after {
  content: '|';
}
</style>
